import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import SuccessMessage from '@kurtosys/ksys-app-components/dist/components/message/SuccessMessage';

export default InjectedStyledComponent(SuccessMessage, 'app', ['successMessage']);
